import { postRequest, getRequest } from "app/axiosClient";
import {
  showLoader,
  hideLoader,
} from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import { setquotesList } from "./QuotesSlice";

export const getQuotesListByCompanyIdAPI = (pagination) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Client/GetEstimatesListByCompanyId`, pagination)
      .then((res) => {
        dispatch(
          setquotesList({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Estimates.Notification.Anerroroccurredwhileretrievingestimates"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Estimates.Notification.Anerroroccurredwhileretrievingestimates"
    );
  }
};
